;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('name', NameFilter)

  /**
   *
   */
  function NameFilter () {
    /**
     * Return the fullname of an user
     * @param user
     * @returns {String}
     */
    var operation = function (user) {
      if (Array.isArray(user)) {
        return user.map(operation)
      }

      if (user.fullname) {
        return user.fullname
      }
      if (user.name) {
        return user.name
      }
      return user.firstname + ' ' + user.lastname
    }

    return operation
  }
})(window.angular)
